import {CurrencyConfiguration} from "@next/utils"
import {BundleSummaryData} from "../searchApi/bundle"
import {SuitSummaryData} from "../searchApi/suit"
import {ProductSummaryData} from "../searchApi/product"
import {SofaSummaryData} from "../searchApi/sofa"
import {AdditionalColourchipsLoadingState} from "../AdditionalColourchipsLoadingState"
import {ItemOptionLiteContract} from "../searchApi/itemLite"

export enum FavErrorToolTipType {
    MaxLimit,
    Error,
}

export interface ColourChipConfig {
    lg: number
    xl: number
}

export type SummaryData = ProductSummaryData | SuitSummaryData | SofaSummaryData | BundleSummaryData
export interface ProductSummaryState {
    canLoadVisibleColourways: boolean
    hasLoadedVisibleColourways: boolean
    isFav: boolean
    enableReviewStars: boolean
    isLoadingFav: boolean
    showFavErrorToolTip: FavErrorToolTipType | null
    enabledSearchDesc: boolean
    summaryData: SummaryData
    animateFavouriteIcon: boolean
    enableBrandDisplay: boolean
    enableSingleLineTitle: boolean
    colourchipSelected: number
    mobileThumbnailConfig: MobileThumbnailConfig
    colourChipConfig: ColourChipConfig
    maxNumberOfSofaColourways: number | null
    maxNumberOfHomewareColourways: number | null
    additionalColourchipsLoading: AdditionalColourchipsLoadingState
    numberOfAllColourways: number
    colourwaysHasSale: boolean
    colourwaysHasRating: boolean
    colourwaysHasStarRatingWithRangedPrice: boolean
    imageRatio: string
    brandedMarkdownSalePrice: boolean
    akamaiImageParams: AkamaiImageParams
    displayFitIcons: boolean
    displayNewIn: boolean
    enableSingleLineBrandName: boolean
    globalPriceFormattingConfig: CurrencyConfiguration
    useProductAggregator: boolean
    savingsSashConfig: SavingsSashConfig
    enableFurtherReductionsSash: boolean
    enableQuickAddToBag: boolean
    sizeOptionSelected?: ItemOptionLiteContract
    chain?: string
}

export interface AkamaiImageParams {
    lg: string
    sm: string
}

export interface MobileThumbnailConfig {
    xs: number
    sm: number
    md: number
}

export interface ColourChip {
    itemNumber: string
    colourChipUrl: string
    linkUrl: string
    isSelected?: boolean
    colour?: string | null
    title: string
    price: string
    currencyCode: string
    altText: string
    department: string
}

export interface Imagery {
    folder: string
    akamaiImageManagerParams: AkamaiImageParams
    dimension: string
    ratio: string
    usePDPImage: boolean
}

export interface SavingsSashConfig {
    sale: number
    clearance: number
}

export type ColourChipsPerRow = {
    lg: number
    xl: number
}

export interface SaleSashConfig {
    type: string | null
    position: string | null
}
